'use client'

import { UserContext, type TUserContext } from '@lib/analytics'
import type { ReactNode } from 'react'

export interface UserAnalyticsWrapperProps {
  readonly value: TUserContext | null
  readonly children: ReactNode
}

export default function UserAnalyticsWrapper({ value, children }: UserAnalyticsWrapperProps) {
  return <UserContext.Provider value={value}>{children}</UserContext.Provider>
}
